import React from 'react';
import { motion } from 'framer-motion';
import { Target, FileCheck, Landmark, ArrowRight } from 'lucide-react';

const Slide5Audience = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col justify-center relative overflow-hidden">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <div className="max-w-5xl mx-auto w-full">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="mb-16"
                >
                    <h2 className="text-4xl lg:text-6xl font-bold mb-2">Evolution of the <span className="text-primary">Autonomous Financial Assistant</span> a.k.a ADI</h2>
                    <p className="text-xl text-muted-foreground">Seamless move from Insight to Action.</p>
                </motion.div>

                {/* Timeline */}
                <div className="relative border-l-2 border-dashed border-border ml-4 lg:ml-0 lg:border-l-0 lg:border-t-2 lg:flex lg:items-start lg:gap-12 lg:pt-12">

                    {/* NOW Phase */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="pl-12 lg:pl-0 lg:w-1/2 relative mb-12 lg:mb-0"
                    >
                        {/* Dot */}
                        <div className="absolute -left-[9px] top-0 lg:-top-[57px] lg:left-0 w-6 h-6 bg-primary rounded-full border-4 border-background shadow-[0_0_20px_hsl(120,100%,50%)]" />

                        <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                            NOW <span className="text-sm font-normal text-muted-foreground bg-muted/20 px-3 py-1 rounded-full">Current State</span>
                        </h3>

                        <div className="grid gap-4">
                            <div className="p-4 bg-card border border-border rounded-lg flex items-center gap-4">
                                <div className="p-2 bg-primary/10 rounded-md">
                                    <Target className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-white">AI-Driven Suggestion</h4>
                                    <p className="text-sm text-muted-foreground">Budget optimization & Risk Mitigation</p>
                                </div>
                            </div>
                            <div className="p-4 bg-card border border-border rounded-lg flex items-center gap-4">
                                <div className="p-2 bg-primary/10 rounded-md">
                                    <ArrowRight className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-white">Spending Control</h4>
                                    <p className="text-sm text-muted-foreground">Subscription & expense pruning</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    {/* FUTURE Phase */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="pl-12 lg:pl-0 lg:w-1/2 relative"
                    >
                        {/* Dot */}
                        <div className="absolute -left-[9px] top-0 lg:-top-[57px] lg:left-0 w-6 h-6 bg-background border-2 border-muted-foreground rounded-full" />

                        <h3 className="text-3xl font-bold text-muted-foreground mb-6 flex items-center gap-3">
                            NEXT <span className="text-sm font-normal text-muted-foreground bg-muted/10 px-3 py-1 rounded-full">Future State</span>
                        </h3>

                        <div className="grid gap-4 opacity-70">
                            <div className="p-4 bg-card border border-border rounded-lg flex items-center gap-4 border-dashed">
                                <div className="p-2 bg-muted/20 rounded-md">
                                    <FileCheck className="w-5 h-5 text-muted-foreground" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-white">Regulatory Maturity</h4>
                                    <p className="text-sm text-muted-foreground">RIA-compliant advisory</p>
                                </div>
                            </div>
                            <div className="p-4 bg-card border border-border rounded-lg flex items-center gap-4 border-dashed">
                                <div className="p-2 bg-muted/20 rounded-md">
                                    <Landmark className="w-5 h-5 text-muted-foreground" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-white">Execution</h4>
                                    <p className="text-sm text-muted-foreground">Broker-integrated trade execution</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default Slide5Audience;